import React from 'react';
import Permissions from 'react-redux-permissions';

export default ({ children }) => (
  <Permissions allowed={['ShowHiddenFeatures']}>{children}</Permissions>
);
